module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_j_leucistic.7efb2152.png";